import {
  SearchAssetRequest,
  SearchMessageRequest,
  SearchOrgRequest,
  SearchProductCatalogueRequest,
  SearchProductRequest,
  SearchTagRequest,
  SearchTaskRequest,
  SearchTeamRequest,
  SearchUserRequest,
} from '@askporter/client-grieg-lyric';

type SearchRequestUnion =
  | SearchTaskRequest
  | SearchAssetRequest
  | SearchUserRequest
  | SearchOrgRequest
  | SearchTeamRequest
  | SearchProductRequest
  | SearchProductCatalogueRequest
  | SearchMessageRequest
  | SearchTagRequest;

/**
 * When a user types in free text, the results they get should be sorted by how closely they match the free text.
 * In order to do this, we need to set the sort to RELEVANCE when a freeText search is performed unless the user has already selected a sort option.
 */
export const handleFreeTextSearch = <SearchPayload extends SearchRequestUnion>({
  search,
  freeText,
  defaultSort,
  hasUserSelectedSort,
}: {
  search: SearchPayload;
  freeText: string;
  defaultSort: SearchPayload['sort'];
  hasUserSelectedSort: boolean;
}): SearchPayload => {
  // If a user has selected a sort option, we want to keep that sort option
  if (hasUserSelectedSort) {
    return { ...search, freeText, page: 1 };
  }

  // Else if the user has not selected a sort option, we want to set the sort to RELEVANCE when a freeText search is performed
  return { ...search, freeText, sort: freeText ? 'RELEVANCE' : defaultSort, page: 1 };
};
